<unity-action-shared [action]="$action()" [disabled]="$disabled()" (clickEvent)="onClickDelete()" />

@if ($showConfirmDialog()) {
  <unity-dialog-confirm-shared [title]="$confirmationTitle()" (confirmEvent)="onConfirmDelete()" (closeEvent)="onConfirmClose()">
    <p>{{ $confirmationMessage() }}</p>
  </unity-dialog-confirm-shared>
}
